module.exports = __webpack_public_path__ + "media/boys_basement.045a6cbb.ogg";